import React from "react";
import PropTypes from "prop-types";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Empty from "antd/es/empty";

const ReportsManagerAccordionTable = ({
  rows = [],
  expandedManagerIds = new Set(),
  onToggleManager,
  columns = [],
  emptyDescription = "No data for client managers",
  formatCell,
}) => {
  if (!rows.length) {
    return <Empty description={emptyDescription} />;
  }

  const renderCell = (row, column) => {
    const value = row?.[column.id];
    if (typeof formatCell === "function") {
      return formatCell(column.id, value, row);
    }
    return value ?? "—";
  };

  return (
    <div className="timesheet-manager-accordion-wrap">
      <table className="documents-table dashboard-table timesheet-manager-accordion-table">
        <thead>
          <tr>
            <th style={{ width: "24%" }}>Employee Name</th>
            {columns.map((column) => (
              <th key={column.id} style={column.width ? { width: column.width } : undefined}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((manager) => {
            const isExpanded = expandedManagerIds.has(String(manager.managerId));
            const hasChildren = (manager.children || []).length > 0;

            return (
              <React.Fragment key={manager.managerId}>
                <tr
                  className={
                    "timesheet-manager-row" +
                    (hasChildren ? " timesheet-manager-row--expandable" : "")
                  }
                >
                  <td className="timesheet-manager-name-cell">
                    {hasChildren ? (
                      <button
                        type="button"
                        className="timesheet-manager-toggle"
                        onClick={() => onToggleManager(manager.managerId)}
                        aria-expanded={isExpanded}
                      >
                        {isExpanded ? (
                          <KeyboardArrowDownIcon fontSize="small" />
                        ) : (
                          <KeyboardArrowRightIcon fontSize="small" />
                        )}
                        <span className="timesheet-manager-name">
                          {manager.employee_name}
                        </span>
                      </button>
                    ) : (
                      <div className="timesheet-manager-name-static">
                        <span className="timesheet-manager-name">
                          {manager.employee_name}
                        </span>
                      </div>
                    )}
                  </td>
                  {columns.map((column) => (
                    <td key={`${manager.managerId}-${column.id}`}>
                      {renderCell(manager, column)}
                    </td>
                  ))}
                </tr>

                {isExpanded &&
                  (manager.children || []).map((child) => (
                    <tr
                      key={`${manager.managerId}-${child.employee_id}`}
                      className="timesheet-employee-row"
                    >
                      <td className="timesheet-employee-name-cell">
                        {child.employee_name}
                      </td>
                      {columns.map((column) => (
                        <td key={`${manager.managerId}-${child.employee_id}-${column.id}`}>
                          {renderCell(child, column)}
                        </td>
                      ))}
                    </tr>
                  ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

ReportsManagerAccordionTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
  expandedManagerIds: PropTypes.instanceOf(Set),
  onToggleManager: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      width: PropTypes.string,
    }),
  ),
  emptyDescription: PropTypes.string,
  formatCell: PropTypes.func,
};

export default ReportsManagerAccordionTable;
